import { getRoomResource, isRoomResourceAvailable } from "../../utils/room-resource-state-utils";
import { unavailableRoomResourceReason } from "../../utils/room-resource-ui-utils";

export const MEDIA_ACTION_STATE = Object.freeze({
  HIDDEN: "hidden",
  PERMISSION_DENIED: "permission-denied",
  PERMISSION_REQUIRED: "permission-required",
  ACTIVE: "active",
  INACTIVE_OWNED: "inactive-owned",
  UNAVAILABLE: "unavailable",
  AVAILABLE: "available"
});

export function resolveMediaResourceAvailability({
  roomResourceState,
  resourceId,
  label,
  locallyOwned = false,
  fallbackReason = null
} = {}) {
  const resource = getRoomResource(roomResourceState, resourceId);
  const canAcquire = locallyOwned || isRoomResourceAvailable(roomResourceState, resourceId);

  return {
    resource,
    canAcquire,
    unavailableReason: unavailableRoomResourceReason({
      label,
      resource,
      locallyActive: locallyOwned,
      fallbackReason
    })
  };
}

export function resolveMediaActionState({
  permissionDenied = false,
  permissionRequired = false,
  locallyOwned = false,
  active = false,
  unsupported = false,
  unavailableReason = null
} = {}) {
  if (permissionDenied) {
    return {
      state: MEDIA_ACTION_STATE.PERMISSION_DENIED,
      blocked: true,
      hidden: false,
      permissionRequired: false,
      unavailableReason
    };
  }

  if (locallyOwned) {
    return {
      state: active ? MEDIA_ACTION_STATE.ACTIVE : MEDIA_ACTION_STATE.INACTIVE_OWNED,
      blocked: false,
      hidden: false,
      permissionRequired: false,
      unavailableReason: null
    };
  }

  if (unsupported) {
    return {
      state: MEDIA_ACTION_STATE.HIDDEN,
      blocked: false,
      hidden: true,
      permissionRequired: false,
      unavailableReason: null
    };
  }

  if (unavailableReason) {
    return {
      state: MEDIA_ACTION_STATE.UNAVAILABLE,
      blocked: true,
      hidden: false,
      permissionRequired: false,
      unavailableReason
    };
  }

  if (permissionRequired) {
    return {
      state: MEDIA_ACTION_STATE.PERMISSION_REQUIRED,
      blocked: false,
      hidden: false,
      permissionRequired: true,
      unavailableReason: null
    };
  }

  return {
    state: MEDIA_ACTION_STATE.AVAILABLE,
    blocked: false,
    hidden: false,
    permissionRequired: false,
    unavailableReason: null
  };
}
